function formatDate(dateStr) {
    if (moment(dateStr, moment.ISO_8601, true).isValid()) {
        return moment(dateStr).format('DD/MM/YYYY');
    } else if (moment(dateStr, 'YYYY-MM-DD', true).isValid()) {
        return moment(dateStr, 'YYYY-MM-DD').format('DD/MM/YYYY');
    } else {
        return dateStr;
    }
}

export function createTable(headerMapping, data) {
    const table = $('<table class="theme-dark"></table>');
    
    const thead = $('<thead></thead>');  // Cabeçalho da tabela
    const tbody = $('<tbody></tbody>');  // Corpo da tabela

    // Criar o cabeçalho da tabela com base no headerMapping, ou usar chaves dos dados como fallback
    const headerRow = $('<tr></tr>'); // Linha do cabeçalho
    for (const key in data) {
        if (headerMapping && headerMapping.hasOwnProperty(key)) {
            headerRow.append('<th>' + headerMapping[key] + '</th>');
        } else {
            headerRow.append('<th>' + key + '</th>');
        }
    }
    thead.append(headerRow);
    table.append(thead);

    const numRows = Math.max(...Object.values(data).map(arr => arr.length));

    for (let i = 0; i < numRows; i++) {
        const row = $('<tr></tr>');  // Cria uma nova linha
        for (const key in data) {
            let cellData = data[key][i];
            
            if (typeof cellData === 'string') {
                cellData = formatDate(cellData);
            } else if (typeof cellData === 'number') {
                cellData = cellData.toFixed(2);
                // cellData = cellData;
            }
            row.append('<td>' + cellData + '</td>');
        }
        tbody.append(row);  // Adiciona a linha ao corpo da tabela
    }

    table.append(tbody);
    return table;
}